module.exports = "/_next/static/images/stripe4-46e0ff4ec0885406eb65d02bd5880a9d.png";